import React from 'react';

interface CrmEmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryHint?: string;
}

export const CrmEmptyState: React.FC<CrmEmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  secondaryHint,
}) => (
  <div className="rounded-2xl border border-border bg-surface p-12 text-center shadow-sm">
    <h3 className="text-lg font-medium text-fg">{title}</h3>
    <p className="mt-2 text-fg-muted">{description}</p>
    {secondaryHint ? <p className="mt-3 text-sm text-fg-muted">{secondaryHint}</p> : null}
    {actionLabel && onAction ? (
      <button
        type="button"
        onClick={onAction}
        className="btn-primary mt-6 inline-flex rounded-xl px-4 py-2 text-sm font-medium"
      >
        {actionLabel}
      </button>
    ) : null}
  </div>
);
